export function videoModal() {
  const videoExists = document.querySelector('.item.type-video') !== null;
  if (videoExists) {
    document
      .querySelectorAll('.type-video .thumb-link')
      .forEach((link) => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const url = this.getAttribute('href');
          const modal = document.getElementById('videoModal');
          const container = document.getElementById('videoContainer');

          // Remove old video if any
          const oldMedia = container.querySelector('iframe, video');
          if (oldMedia) oldMedia.remove();

          let mediaEl;

          if (url.includes('youtube.com') || url.includes('youtu.be')) {
            // Ensure it's an embed URL
            let embedUrl = url;
            if (url.includes('watch?v=')) {
              const videoId = url.split('watch?v=')[1];
              embedUrl = 'https://www.youtube.com/embed/' + videoId;
            }
            mediaEl = document.createElement('iframe');
            mediaEl.src = embedUrl + '?autoplay=1';
            mediaEl.allow = 'autoplay; encrypted-media';
          } else {
            mediaEl = document.createElement('video');
            mediaEl.src = url;
            mediaEl.controls = true;
            mediaEl.autoplay = true;
          }

          container.appendChild(mediaEl);
          modal.style.display = 'flex';
        });
      });

    // Close modal
    document.getElementById('videoClose').addEventListener('click', () => {
      const modal = document.getElementById('videoModal');
      modal.style.display = 'none';
      const media = modal.querySelector('iframe, video');
      if (media) media.remove();
    });

    // Close if click outside video
    document.getElementById('videoModal').addEventListener('click', (e) => {
      if (e.target.id === 'videoModal') {
        document.getElementById('videoClose').click();
      }
    });
  }
}
